module.exports = __webpack_public_path__ + "img/down.ee2b023b.png";